import styles from "../../../views/ReportView/ReportView.module.css";
import Swal from "sweetalert2";
import axios from "axios";

const AltaButton = ({ user, setUser }) => {
  const handleAlta = async () => {
    const id = user.dni;
    try {
      const res = await axios.post(process.env.REACT_APP_LEALTAD_CASUALTY_PERSON_API, {
        id,
        newStatus: "Alta",
      });

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: "La Persona Humana se dio de alta correctamente",
        });
        setUser({
          ...user,
          status: "Alta",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  return (
    <button type="button" onClick={handleAlta} className={styles.Lealtadaltabaja}>
      Dar de Alta
    </button>
  );
};

export default AltaButton;